module.exports = __webpack_public_path__ + "static/media/univ_le_havre.db6a9c46.jpg";